import { getCoachLayoutAction } from "../../../../Actions/LogicActions/Checkout/Seating/GetCoachLayoutAction";
import { getFloorPlanIconAction } from "../../../../Actions/LogicActions/Checkout/Seating/GetFloorPlanIconAction";
import { getPlaceMapsAction } from "../../../../Actions/LogicActions/Checkout/Seating/GetPlaceMapsAction";
import { getEarnPointsCheckoutAction } from "../../../../Actions/LogicActions/TrainOffer/GetEarnPointsCheckoutAction";
import { confirmSeatSelectionAction } from "../../../../Actions/UIActions/Checkout/Seating/ConfirmSeatSelectionAction";
import { defaultSeatAllocationAction } from "../../../../Actions/UIActions/Checkout/Seating/DefaultSeatAllocationAction";
import { openCloseSeatingPopupAction } from "../../../../Actions/UIActions/Checkout/Seating/OpenCloseSeatingPopupAction";
import { preSelectSeatAction } from "../../../../Actions/UIActions/Checkout/Seating/PreSelectSeatAction";
import { selectSeatAction } from "../../../../Actions/UIActions/Checkout/Seating/SelectSeatAction";
import { setCoachAction } from "../../../../Actions/UIActions/Checkout/Seating/SetCoachAction";
import { setCursorAction } from "../../../../Actions/UIActions/Checkout/Seating/SetCursorAction";
import { setUnavailableSeatAction } from "../../../../Actions/UIActions/Checkout/Seating/SetUnavailableSeatAction";
import { ExecutionStatus } from "../../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../../core/events/EventBus";
import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { checkoutTree } from "../../../../Orchestrator/ConstantTree/CheckoutPage/CheckoutTree";
import { IDefaultSeatToPassengerAction, ISeatingPlaceMapAction, ISelectSeatAction } from "../../../../Orchestrator/Types/Interface/EventParams/SeatingAction";
import { IAddonsPassengerLeg, ITransformedMealForLegs } from "../../../../Orchestrator/Types/Interface/IAddOns";
import { IPreSelectParams } from "../../../../Orchestrator/Types/Types/BookingTypes";
import { SeatingMapContext } from "../Context/SeatingMapContext";

class SeatingMapInitStep extends StepFlow {
    get stepName() { return "SeatingMapInit_Step"; }

    async onEventSetup(): Promise<void> {

        this.registerEventSubscription(
            _eventBus.on<{ meal: ITransformedMealForLegs, addonsPassengerList: IAddonsPassengerLeg[] }, void>({
                eventName: checkoutTree.EarnPoint.GetPoints,
                handler: async (payload) => {
                    getEarnPointsCheckoutAction.setParams({
                        meal: payload.data?.meal ?? {},
                        addonsPassengerList: payload.data?.addonsPassengerList ?? []
                    });
                    getEarnPointsCheckoutAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<{ openModal: boolean, booking?: any, isChangeDate?: boolean, isQuickExchange?: boolean, isManageSeating?: boolean }, void>({
                eventName: checkoutTree.Seating.Popup.openClose,
                handler: async (payload) => {
                    let context = this.getCtx<SeatingMapContext>("seatingMapContext")!;
                    context.openClosePopup = payload.data?.openModal!
                    openCloseSeatingPopupAction.setParams({
                        openModal: context.openClosePopup,
                        booking: payload.data?.booking,
                        isChangeDate: payload.data?.isChangeDate,
                        isQuickExchange: payload.data?.isQuickExchange,
                        isManageSeating: payload.data?.isManageSeating
                    });
                    openCloseSeatingPopupAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<{
                seats: Record<string, string>[],
                requestBody: any,
                bookingId: string,
                segmentIndex: number,
                intl: any,
                isManageSeating?: boolean
            }, void>({
                eventName: checkoutTree.Seating.Confirm.Click,
                handler: async (payload) => {
                    let context = this.getCtx<SeatingMapContext>("seatingMapContext")!;
                    context.seats = payload.data?.seats!
                    confirmSeatSelectionAction.setParams({
                        seats: context.seats,
                        requestBody: payload.data?.requestBody,
                        bookingId: payload.data?.bookingId!,
                        segmentIndex: payload.data?.segmentIndex!,
                        intl: payload.data?.intl!,
                        isManageSeating: payload.data?.isManageSeating!
                    });
                    await confirmSeatSelectionAction.execute();
                    if (confirmSeatSelectionAction.status.executionStatus == ExecutionStatus.SUCCESS) {
                        context.seatsData = confirmSeatSelectionAction.result?.result!
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<ISeatingPlaceMapAction, void>({
                eventName: checkoutTree.Seating.Get.PlaceMap,
                handler: async (payload) => {
                    let context = this.getCtx<SeatingMapContext>("seatingMapContext")!;
                    getPlaceMapsAction.setParams(payload.data!);
                    await getPlaceMapsAction.execute();
                    if (getPlaceMapsAction.status.executionStatus == ExecutionStatus.SUCCESS) {
                        context.placeMapData = getPlaceMapsAction.result
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: checkoutTree.Seating.Get.FloorPlanIcon,
                handler: async () => {
                    let context = this.getCtx<SeatingMapContext>("seatingMapContext")!;
                    await getFloorPlanIconAction.execute();
                    if (getFloorPlanIconAction.status.executionStatus == ExecutionStatus.SUCCESS) {
                        context.floorPlanIcon = getFloorPlanIconAction.result
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<string, void>({
                eventName: checkoutTree.Seating.Coach.Set,
                handler: async ({ data }) => {
                    let context = this.getCtx<SeatingMapContext>("seatingMapContext")!;
                    if (context) {
                        context.coach = data || ""
                    }
                    setCoachAction.setParams(context.coach)
                    await setCoachAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IPreSelectParams, void>({
                eventName: checkoutTree.Seating.Seat.PreSelect,
                handler: async ({ data }) => {
                    let context = this.getCtx<SeatingMapContext>("seatingMapContext")!;
                    if (context && data) {
                        preSelectSeatAction.setParams(data);
                        await preSelectSeatAction.execute();
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: checkoutTree.Seating.Seat.Cursor,
                handler: async (data: any) => {
                    setCursorAction.setParams(data.data);
                    await setCursorAction.execute();
                }
            })
        );


        this.registerEventSubscription(
            _eventBus.on<string, void>({
                eventName: checkoutTree.Seating.Coach.getLayout,
                handler: async ({ data }) => {
                    let context = this.getCtx<SeatingMapContext>("seatingMapContext")!;
                    if (context) {
                        context.layoutId = data || ""
                    }
                    getCoachLayoutAction.setParams(context.layoutId)
                    await getCoachLayoutAction.execute();
                    if (getCoachLayoutAction.status.executionStatus == ExecutionStatus.SUCCESS) {
                        context.coachLayoutData = getCoachLayoutAction.result
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<ISelectSeatAction, void>({
                eventName: checkoutTree.Seating.Seat.Select,
                handler: async (payload) => {
                    selectSeatAction.setParams(payload.data!);
                    await selectSeatAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<string[], void>({
                eventName: checkoutTree.Seating.UnavailableSeat.Set,
                handler: async ({ data }) => {
                    let context = this.getCtx<SeatingMapContext>("seatingMapContext")!;
                    setUnavailableSeatAction.setParams(data!)
                    await setUnavailableSeatAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IDefaultSeatToPassengerAction, void>({
                eventName: checkoutTree.Seating.Seat.DefaultSeatAllocation,
                handler: async (payload) => {
                    defaultSeatAllocationAction.setParams(payload.data!);
                    await defaultSeatAllocationAction.execute();
                }
            })
        )

    }

    async onExecute(): Promise<void> {
        this.setCtx("seatingMapContext", SeatingMapContext)
        console.log("Seating Map Initial Step Executed.....");
    }
}

export const SeatingMapInitStepDeclaration = new StepDefinition({
    stepName: "SeatingMapInit_Step",
    stepClass: SeatingMapInitStep
});